// Material helpers
import { createMuiTheme } from '@material-ui/core';

import typography from '../common/typography';
import overrides from './overrides';
import palette from './palette';

const theme = createMuiTheme({
  palette,
  typography,
  overrides,
  props: {
    MuiMenuItem: {
      disableRipple: true,
    },
  },
});

export default theme;
